import * as React from 'react';

export const CopySvg: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none'>
    <path
      stroke='#60708E'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M20 9h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2Z'
    />
    <path
      stroke='#60708E'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'
    />
  </svg>
);
